/**
 * Phone numbers as one spelling.
 *
 * Mirrors the server's normalizePhone (internal/service/user/identifier.go):
 * spaces, dashes, dots and brackets are dropped, and a number without a
 * country code is read as Nigerian. Saving the E.164 form means a number typed
 * as "0803 123 4567" and one typed as "+234 803 123 4567" are the same number
 * everywhere, including at sign-in.
 */
export const normalizePhone = (raw: string): string | null => {
  const trimmed = raw.trim()
  if (!trimmed || /[^\d+\s\-().]/.test(trimmed)) return null
  const plus = trimmed.startsWith('+')
  let digits = trimmed.replace(/\D/g, '')
  if (plus) {
    // already international
  } else if (digits.startsWith('00')) {
    digits = digits.slice(2)
  } else if (digits.startsWith('0') && digits.length === 11) {
    digits = `234${digits.slice(1)}`
  } else if (digits.length === 10 && /^[789]/.test(digits)) {
    digits = `234${digits}`
  } else if (!(digits.startsWith('234') && digits.length === 13)) {
    return null
  }
  if (digits.length < 8 || digits.length > 15 || digits.startsWith('0')) return null
  return `+${digits}`
}

/** "+2348031234567" → "0803 123 4567" for Nigerian numbers; others as stored. */
export const formatPhone = (e164: string): string => {
  const match = /^\+234(\d{3})(\d{3})(\d{4})$/.exec(e164)
  return match ? `0${match[1]} ${match[2]} ${match[3]}` : e164
}
